import React, { useState } from "react";
import { X, Download, Mail } from "lucide-react";
import SummaryTab from "./tabs/SummaryTab";
import EarningsTab from "./tabs/EarningsTab";
import AdjustmentsTab from "./tabs/AdjustmentsTab";
import TaxesTab from "./tabs/TaxesTab";
import AuditHistoryTab from "./tabs/AuditHistoryTab";
import TimeTab from "./tabs/TimeTab";
import PlaceholderTab from "./tabs/PlaceholderTab";

const TABS = [
  { key: "summary", label: "Summary" },
  { key: "time", label: "Time" },
  { key: "commissions", label: "Commissions" },
  { key: "pieceRate", label: "Piece Rate" },
  { key: "earnings", label: "Earnings" },
  { key: "adjustments", label: "Adjustments" },
  { key: "taxes", label: "Taxes" },
  { key: "audit", label: "Audit History" },
];

export default function PayrollDetailDrawer({
  row, period, adjustments, taxInfo, canPayroll,
  onClose, onAddAdjustment, onAddSpiff, onAddHoliday, onSavePdf, onEmail, pdfBusy, commissionsSlot, pieceRateSlot, onOpenTimeModal, onApproveAdjustment,
}) {
  const [tab, setTab] = useState("summary");
  if (!row) return null;

  return (
    <div className="fixed inset-0 z-[110] flex justify-end bg-slate-900/50 backdrop-blur-sm" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="bg-white w-full max-w-3xl h-full overflow-y-auto shadow-2xl" data-testid="payroll-detail-drawer">
        <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between sticky top-0 bg-white z-10">
          <div>
            <div className="text-[15px] font-bold text-slate-900">{row.tech.name}</div>
            <div className="text-[12px] text-slate-500">{period?.startDate} → {period?.endDate}</div>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={onSavePdf} disabled={pdfBusy} data-testid="payroll-detail-download-pdf"
              className="h-8 px-2.5 rounded-md border border-slate-200 text-[12px] font-semibold text-slate-700 hover:bg-slate-50 flex items-center gap-1.5 disabled:opacity-50">
              <Download className="h-3.5 w-3.5" /> PDF
            </button>
            <button onClick={onEmail} data-testid="payroll-detail-email"
              className="h-8 px-2.5 rounded-md border border-blue-200 text-[12px] font-semibold text-blue-700 hover:bg-blue-50 flex items-center gap-1.5">
              <Mail className="h-3.5 w-3.5" /> Email
            </button>
            <button onClick={onClose} data-testid="payroll-detail-close" className="h-8 w-8 rounded-md hover:bg-slate-100 flex items-center justify-center">
              <X className="h-4 w-4 text-slate-500" />
            </button>
          </div>
        </div>
        <div className="px-5 pt-3 border-b border-slate-100 flex gap-1 overflow-x-auto sticky top-[65px] bg-white z-10">
          {TABS.map((t) => (
            <button key={t.key} onClick={() => setTab(t.key)} data-testid={`payroll-detail-tab-${t.key}`}
              className={`px-3 py-2 text-[12.5px] font-semibold whitespace-nowrap border-b-2 transition-colors ${tab === t.key ? "border-blue-600 text-blue-700" : "border-transparent text-slate-500 hover:text-slate-700"}`}>
              {t.label}
            </button>
          ))}
        </div>
        <div className="p-5">
          {tab === "summary" && <SummaryTab row={row} adjustments={adjustments} />}
          {tab === "time" && <TimeTab row={row} period={period} adjustments={adjustments} canPayroll={canPayroll} onOpenTimeModal={onOpenTimeModal} />}
          {tab === "commissions" && (commissionsSlot || <PlaceholderTab note="Per-job commission line editing and technician splits are coming in a later phase." />)}
          {tab === "pieceRate" && (pieceRateSlot || <PlaceholderTab note="Piece-rate line editing is coming in a later phase." />)}
          {tab === "earnings" && <EarningsTab row={row} adjustments={adjustments} canPayroll={canPayroll} onAddEarning={onAddAdjustment} onAddSpiff={onAddSpiff} onAddHoliday={onAddHoliday} />}
          {tab === "adjustments" && <AdjustmentsTab adjustments={adjustments} onApprove={onApproveAdjustment} isLocked={period?.status === "LOCKED"} />}
          {tab === "taxes" && <TaxesTab taxInfo={taxInfo} />}
          {tab === "audit" && <AuditHistoryTab periodId={period?.id} employeeAdjustmentIds={(adjustments || []).map((a) => a.id)} />}
        </div>
      </div>
    </div>
  );
}
